import { z } from 'zod';
/** Allowed workspace playbook tag values */
export const WORKSPACE_PLAYBOOK_TAGS = [
    'already_in_progress',
    'already_done',
];
export const WorkspacePlaybookTagSchema = z.enum(WORKSPACE_PLAYBOOK_TAGS);
export const WorkspacePlaybookTagsSchema = z.array(WorkspacePlaybookTagSchema);
//# sourceMappingURL=workspace-playbook-tags.js.map